import React from 'react';
import Grid from '../../Grid';
import Typography from '../../Typography';
import ActionIcon from '../ActionIcon/ActionIcon';
import trash from '../../../assets/trash.png';
import styles from './ExtraItem.module.sass';
import currency from 'currency.js';

const ExtraItem = ({ opeId, extra, editable, removeItem, usePriceWithout }) =>
  <Grid container item justify='space-between' alignItems='center' classes={styles.wrapper}>
    <Grid container item justify='center' xs={4}>
      {editable &&
        <ActionIcon icon={trash} text='Remove' action={() => removeItem(opeId, 'extras')} />
      }
    </Grid>
    <Grid container item xs={8} justify='space-between' classes={styles.infoWrapper}>
      <Grid item>
        <Typography weight={600} classes={styles.extraName}>{extra.name}</Typography>
      </Grid>
      <Grid item>
        {currency(usePriceWithout && extra.prices[0].priceWithout ? extra.prices[0].priceWithout : extra.prices[0].price).format()}
      </Grid>
    </Grid>
  </Grid>

export default ExtraItem;
